import {
  AUTH_TOKEN,
  IS_2FA_ENABLED,
  AUTHENTICATED,
  SHOW_AUTH_MESSAGE,
  HIDE_AUTH_MESSAGE,
  SIGNOUT_SUCCESS,
  SIGNUP_SUCCESS,
  SHOW_LOADING,
  SIGNIN_WITH_GOOGLE_AUTHENTICATED,
  SIGNIN_WITH_FACEBOOK_AUTHENTICATED,
  SIGNIN_WITH_EMAIL_AUTHENTICATED,
  SET_QR,
  USER_VERIFIED,
  SET_TOKEN,
  RESET_USER_VERIFICATION,
  SET_IS_2FA_ENABLED,
  SET_LOADING,
  SET_USER_PROFILE,
} from '../constants/Auth';

// Helper function to get initial token
const getInitialToken = () => {
  try {
    return localStorage.getItem(AUTH_TOKEN);
  } catch (error) {
    return null;
  }
};

// Helper function to get initial 2FA status
const getInitial2FAStatus = () => {
  try {
    const status = localStorage.getItem(IS_2FA_ENABLED);
    return status === 'true';
  } catch (error) {
    return false;
  }
};

const initState = {
  loading: false,
  message: '',
  showMessage: false,
  redirect: '/dashboard',
  token: getInitialToken(),
  loginData: {
    UserId: '',
    Email: '',
    AccessToken: '',
    Is2FAEnabled: getInitial2FAStatus(),
  },
  qr: '',
  isVerified: false,
  Is2FAEnabled: getInitial2FAStatus(),
  profile: {
    FullName: '',
    Email: '',
    Privileges: [],
  },
};

const auth = (state = initState, action) => {
  switch (action.type) {
    case AUTHENTICATED:
      return {
        ...state,
        loading: false,
        redirect: '/dashboard',
        token: action.token,
      };
    case SHOW_AUTH_MESSAGE:
      return {
        ...state,
        message: action.message,
        showMessage: true,
        loading: false,
      };
    case HIDE_AUTH_MESSAGE:
      return {
        ...state,
        message: '',
        showMessage: false,
      };
    case SIGNOUT_SUCCESS: {
      return {
        ...state,
        token: null,
        redirect: '/',
        loading: false,
        isVerified: false,
      };
    }
    case SIGNUP_SUCCESS: {
      return {
        ...state,
        loading: false,
        token: action.token,
      };
    }
    case SHOW_LOADING: {
      return {
        ...state,
        loading: true,
      };
    }
    case SET_LOADING: {
      return {
        ...state,
        loading: action.isLoading,
      };
    }
    case SIGNIN_WITH_GOOGLE_AUTHENTICATED: {
      return {
        ...state,
        loading: false,
        token: action.token,
      };
    }
    case SIGNIN_WITH_FACEBOOK_AUTHENTICATED: {
      return {
        ...state,
        loading: false,
        token: action.token,
      };
    }
    case SIGNIN_WITH_EMAIL_AUTHENTICATED: {
      return {
        ...state,
        loginData: action.payload,
      };
    }
    case SET_QR:
      return {
        ...state,
        qr: action.qr,
      };

    case USER_VERIFIED:
      return {
        ...state,
        isVerified: true,
      };
    case SET_TOKEN:
      return {
        ...state,
        token: localStorage.getItem(AUTH_TOKEN),
      };
    case RESET_USER_VERIFICATION:
      return {
        ...state,
        isVerified: false,
      };
    case SET_IS_2FA_ENABLED:
      return {
        ...state,
        Is2FAEnabled: action.Is2FAEnabled,
      };
    case SET_USER_PROFILE:
      return {
        ...state,
        profile: action.payload,
      };
    default:
      return state;
  }
};

export default auth;
